import React, { createContext, useContext, useReducer, useMemo, useCallback } from "react";
import Api from "../utils/api_calls";
import queryString from 'query-string';

const initialState = {
    isLoading: false,
    content: [],
    keepLoading: true,
    filters: {
        p: 1,
        n: 5,
        user_id: null,
        category: null
    },
    attributes: []
};

const UPDATE_ASSETS = 'UPDATE_ASSETS';
const UPDATE_FILTERS = 'UPDATE_FILTERS';
const SET_IS_LOADING = 'SET_IS_LOADING';
const RESET_AND_LOAD_CATEGORY = 'RESET_AND_LOAD_CATEGORY';
const RESET_FILTERS = 'RESET_FILTERS';
const UPDATE_ATTRIBUTES = 'UPDATE_ATTRIBUTES';

const reducer = (state, action) => {
    switch (action.type) {
        case UPDATE_ASSETS: {
            const data = [...action.payload['hydra:member']];
            const keepLoading = data.length !== 0;
            const content = state.filters.p === 1 ? data : state.content.concat(data);
            return { ...state, isLoading: false, keepLoading, content };
        }
        case UPDATE_FILTERS:
            return { ...state, filters: { ...action.payload } };
        case SET_IS_LOADING:
            return { ...state, isLoading: true };
        case RESET_AND_LOAD_CATEGORY: {
            const filters = { ...initialState.filters };
            filters.category = action.payload;
            return { ...state, content: [], keepLoading: true, isLoading: false, filters };
        }
        case RESET_FILTERS: {
            const filters = { ...initialState.filters };
            filters.category = null;
            return { ...state, content: [], keepLoading: true, isLoading: false, filters };
        }
        case UPDATE_ATTRIBUTES:
            return { ...state, attributes: action.payload };
        default:
            return state;
    }
};

const buildParameters = (params, url) =>{
    const filters = {...params};
    const {isHomePage} = TVSite;
    if(!filters.hasOwnProperty('order_by') && isHomePage){
        const validValues = ['date_created', 'stats_es_views_lifetime'];
        const query = window.location.search;
        const params = queryString.parse(query);
        if (params.filter && validValues.includes(params.filter)) {
            filters.order_by = params.filter;
        } else {
            filters.order_by = 'date_created';
        }

    }else if(!filters.order_by){
        filters.order_by = 'date_created';
    }
    let attachSymbol = '&';
    if(!url.includes('?')){
        attachSymbol = '?';
    }
    return attachSymbol+`entity_type=video%2Cphoto&order_by=${filters.order_by}&order=desc&page=${filters.p}&per_page=${filters.n}`
}

const ContentContext = createContext(null);

export const ContentProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const updateFilters = useCallback((payload) => dispatch({ type: UPDATE_FILTERS, payload }), []);
    const setIsLoading = useCallback((payload = false) => dispatch({ type: SET_IS_LOADING, payload }), []);
    const resetAndLoadCategory = useCallback((payload) => dispatch({ type: RESET_AND_LOAD_CATEGORY, payload }), []);
    const resetFilters = useCallback((payload) => dispatch({ type: RESET_FILTERS, payload }), []);
    const updateAttributes = useCallback((payload) => dispatch({ type: UPDATE_ATTRIBUTES, payload }), []);

    const getContent = useCallback((url, filters) => {
        dispatch({ type: SET_IS_LOADING, payload: true });
        return Api.channelService(url + buildParameters(filters, url)).then((response) => dispatch({ type: UPDATE_ASSETS, payload: response.data }));
    }, []);

    const getContentFromChannel = useCallback((url, filters) => {
        dispatch({ type: SET_IS_LOADING, payload: true });
        return Api.content(url, filters.p - 1, null, 6, null).then(response => {
            dispatch({ type: UPDATE_ASSETS, payload: { 'hydra:member': response.data } });
        });
    }, []);

    const getAttributes = useCallback(() => {
        return Api.getCategories(response => {
            console.log("response", response);
            dispatch({ type: UPDATE_ATTRIBUTES, payload: response.data });
        });
    }, []);

    const value = useMemo(() => ({
        content: state.content,
        filters: state.filters,
        isLoading: state.isLoading,
        keepLoading: state.keepLoading,
        attributes: state.attributes,
        updateFilters,
        setIsLoading,
        resetAndLoadCategory,
        resetFilters,
        updateAttributes,
        getContent,
        getContentFromChannel,
        getAttributes
    }), [state, updateFilters, setIsLoading, resetAndLoadCategory, resetFilters, updateAttributes, getContent, getContentFromChannel, getAttributes]);

    return <ContentContext.Provider value={value}>{children}</ContentContext.Provider>;
};

export const useContentContext = () => useContext(ContentContext);
